var referrer =  document.referrer;
$.jobunlockClick= function(jid,sec) {
    if ($('#timer-'+jid).hasClass("timerstarted")) {
        return false;
    }
    else
    {
        var display = document.querySelector('#timer-'+jid);
        var timer = new CountDownTimer(sec,jid); // put second here
        timer.onTick(format).onTick(restart).start(); //start countdown
        $("#timer-"+jid).addClass("timerstarted");
    }
};

function disableButton(key) {
    if (key == 'fbLoginButton') {
        $('.googleLogin').attr('disabled', 'disabled');
        $('.phone-login').attr('disabled', 'disabled');
        $('.email-login').attr('disabled', 'disabled');
        $('.password-login').attr('disabled', 'disabled');
        $('.button-login').attr('disabled', 'disabled');
    } else if (key == 'fbLoginReset') {
        $('.googleLogin').removeAttr('disabled');
        $('.phone-login').removeAttr('disabled');
        $('.email-login').removeAttr('disabled');
        $('.password-login').removeAttr('disabled');
        $('.button-login').removeAttr('disabled');
    } else if (key == 'emailLoginButton') {
        $('.googleLogin').attr('disabled', 'disabled');
        $('.phone-login').attr('disabled', 'disabled');
        $('.fblogin').attr('disabled', 'disabled');
    } else if(key == 'googleLoginReset') {
        $('.fblogin').removeAttr('disabled');
        $('.phone-login').removeAttr('disabled');
        $('.email-login').removeAttr('disabled');
        $('.password-login').removeAttr('disabled');
        $('.button-login').removeAttr('disabled');
    } else if (key == 'googleLoginButton') {
        $('.fblogin').attr('disabled', 'disabled');
        $('.phone-login').attr('disabled', 'disabled');
        $('.email-login').attr('disabled', 'disabled');
        $('.password-login').attr('disabled', 'disabled');
        $('.button-login').attr('disabled', 'disabled');
    }
    else {
        $('.googleLogin').removeAttr('disabled');
        $('.phone-login').removeAttr('disabled');
        $('.fblogin').button('reset');
        $('.fblogin').removeAttr('disabled');
        $('.email-login').removeAttr('disabled');
        $('.password-login').removeAttr('disabled');
        $('.button-login').removeAttr('disabled');
    }
}

function next(next, e) {

    if (next != 0)
    {
        if (e.keyCode != 8)
            document.getElementById(next).focus();
    }

    var codeCount = '';
    $(".clock").each(function (index) {
        var v = $(this).val();
        v = v.trim();
        if (v != '')
        {
            codeCount++;
        }
    });

    if (codeCount > 3)
        $(".login_confirmphonetac").removeClass('disabled');
    else
        $(".login_confirmphonetac").addClass('disabled');
}

// is fb app
function isFacebookApp() {
    var ua = navigator.userAgent || navigator.vendor || window.opera;
    return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);
}

// is fb app
function isInstagramApp() {
    var ua = navigator.userAgent || navigator.vendor || window.opera;
    return  (ua.indexOf('Instagram') > -1) ? true : false;
}

function checkFbLoginState(el) {

    var $btn = $(el);

    var isFbApp = isFacebookApp();
    var isInstagram = isInstagramApp();

    $btn.button("loading");
    $("#logintype").val('fblogin');
    disableButton('allReset');

    if(isInstagram || isFbApp) {
        if (typeof(FB) != 'undefined' && FB != null) {
            FB.getLoginStatus(function (loginStatusresponse) {
                console.log('loginStatusresponse');
                console.log(JSON.stringify(loginStatusresponse));
                if (loginStatusresponse.status === 'connected') {
                    fbLogin($btn, loginStatusresponse);
                } else {
                    console.log("user not connected to facebook");
                    FB.login(function (response) {

                        if (response.status === 'connected') {
                            console.log("now user connected to facebook");
                            fbLogin($btn, response);
                        } else {
                            console.log('Please log ' + 'into this webpage.');
                        }
                    }, {
                        scope: 'email'
                    });

                }

            });
        }
    }else{
        FB.login(function (response) {

            if (response.status === 'connected') {
                console.log("now user connected to facebook");
                fbLogin($btn, response);
            } else {
                console.log('Please log ' + 'into this webpage.');
            }
        }, {
            scope: 'email'
        });
    }

}

function fbLogin($btn, response) {
    console.log('Welcome!  Fetching your information.... ');

    var access_token = FB.getAuthResponse()['accessToken'];

    FB.api('/me', function (resp) {
        uid = response.authResponse.userID;
        var userId = response.authResponse.userID;
        var userName = resp.name;
        var userEmail = resp.email;
        $("#fbid").val(userId);
        $("#register_name").val(userName);
        $("#register_email").val(userEmail);

        $("#fbuid").val(userId);
        $("#fbaccesstoken").val(access_token);

        $.post(canvas_url + "api/jobseeker/fbLogin", {
            'token': access_token,
            '_token': $('meta[name="csrf-token"]').attr('content')
        }, function (data) {

            if (data.status == 'success') //sucess login
            {

                $btn.button('reset');
                disableButton('allReset');

                $.notify({message: notify_msg.success.login}, {type: 'success',z_index: 3000});
                if(referrer !== '')
                {
                    window.location = referrer;
                }
                else
                {
                    window.location = canvas_url;
                }
            }
            else {
                //send ga event
                disableButton('allReset');

            }

        }, "json");

    });
}


var userStatus =  ['inactive', 'ban'];
$(document).ready(function () {
    var referrer =  document.referrer;

    //init phone
    $("#login_phone").intlTelInput({
        separateDialCode : true,
        initialCountry: "MY",
        preferredCountries: ["MY", "SG", "ID", "CN", "TW", "HK","PH", "IN"],
        onlyCountries: ["MY", "ID", "PH", "VN", "TH", "SG","CN", "IN", "PK", "BD"]
    });


    // ----------- normal login --------- //
    $('#form_jobseeker_login').validate({
        rules: {
            email_address: {required:true},
            password: {required:true}
        },
        messages: {
            email_address: {required:'This field is required'},
            password: {required:'This field is required'}
        },
        submitHandler: function() {
            //using default submit function below
            return false;
        }
    });

    $("#form_jobseeker_login").on('submit', function(){

        var _this = $(this);
        var submitBtn = _this.find('.btn');
        _this.prev('.alert').hide()
        var email_address = $("#email_address").val();
        var password = $("#password").val();
        $("#logintype").val('normal');


        if ($('#form_jobseeker_login').valid()) {
            disableButton('emailLoginButton');
            submitBtn.button("loading");

            var jsonData = {
                'email': email_address,
                'password': password,
                '_token': $('meta[name="csrf-token"]').attr('content')
            };

            var request = $.ajax({
                url: canvas_url + "api/jobseeker/login",
                data: jsonData,
                type: 'POST',
                crossDomain: true,
                dataType: 'json'
            });


            request.done(function (data) {
                console.log(data);
                if (data.success)
                {
                    submitBtn.button("reset");
                    $('#login_modal').modal('hide');
                    disableButton('allReset');
                    ga('send', 'event', 'login', 'normal-login','success');
                    $.notify({message: notify_msg.success.login}, {type: 'success',z_index: 3000});
                    if(referrer !== '')
                    {
                        window.location = referrer;
                    }
                    else
                    {
                        window.location = canvas_url;
                    }


                }
                else
                {
                    ga('send', 'event', 'Login', 'email-failed',email_address);
                    disableButton('emailLoginReset');
                    submitBtn.button("reset");
                    document.getElementById('login-alert').innerHTML = notify_msg.error.user_wrong;
                    _this.parents('.login-wrapper').find('.alert').show()
                }
            });
            request.fail(function (jqXHR, textStatus) {
                ga('send', 'event', 'Login', 'email-failed','failed_request');
                disableButton('emailLoginReset');
                submitBtn.button("reset");
                document.getElementById('login-alert').innerHTML = notify_msg.error.user_isnotexist;
                _this.parents('.login-wrapper').find('.alert').show()

            });

        }
    });

    $.verifyphone = function(title,goback,action){

        //open phone modal and hide other modal
        $('.modal').modal('hide');
        $('#phone_modal').data('bs.modal',null); // fixing for statix backdrop
        $("#phone_modal").modal({backdrop: "static", keyboard: "false"});

        //change title
        $('#phone_modal').find('.modal-title').html('\
        <a href="#'+goback+'" data-dismiss="modal" data-toggle="modal" class="close-custom"><i class="fa fa-chevron-left"></i></a> '+title+'\
      ');

        //reset
        $('#m-tacphone').hide();
        $('#m-verfiyphone').show();
        $('#m-confirmphone').hide();
        $("#login_phone").val('');
        $('.tac-input').find('input').val('');
        $('.login_sendphonetac').button("reset");
        $('.login_alreadyhavetac').removeClass('disabled');
        $("#login_phone").attr("disabled",false);
        $("#isPhoneConfirmed").val('no');

        $('#tac_source').val(goback);


        //set type of login
        if(action == 'register'){

            $("#logintype").val('register');

        }else if(action == 'normal'){

            $("#logintype").val('normal');

        }else if(action == 'googleLogin'){

            $("#logintype").val('googleLogin');

        }else if(action == 'googleSignup'){

            $("#logintype").val('googleSignup');

        }else if(action == 'fblogin'){

            $("#logintype").val('fblogin');

        }else if(action == 'byphone'){

            $("#logintype").val('byphone');
        }
    }

    //confirm phone number
    $(".login_confirmphone").bind("click", function () {
        $("#isPhoneConfirmed").val('yes');

        var tacType = $("#tacType").val();
        var dataType = 'tac-'+tacType;

        $('.login_sendphonetac#'+dataType).trigger('click');
    });

    $(".login_confirmphone2").bind("click", function () {
        $("#isPhoneConfirmed").val('yes');
        $(".login_callphonetac").trigger('click');
    });

    //back to verify screen
    $(".login_confirmphoneback").bind("click", function () {
        $('#m-verfiyphone').show();
        $('#m-confirmphone').hide();
        $("#isPhoneConfirmed").val('no');
    });

    //already have code
    $(".login_alreadyhavetac").bind("click", function () {

        if($(this).hasClass('disabled')){
            return false;
        }
        $(".btn-requesttacagain").hide();
        if ($('#timer-111').hasClass("timerstarted")) {
            $(".btn-requesttacagain").show();
        }else{
            $(".btn-requesttacagain").hide();
        }

        //reset
        $('.tac-input').find('input').val('');
        $("#login_phone_error").hide();
        $("#login_code_error").hide();

        $("#login_phone").parents('.form-group').removeClass("has-error");

        var login_phone = $("#login_phone").intlTelInput("getNumber");
        //Added by Ali
        login_phone = login_phone.replace("+",'');
        var countryData = $("#login_phone").intlTelInput("getSelectedCountryData");
        selectedDialCode = countryData['dialCode'];

        if (login_phone == '' || login_phone == selectedDialCode)
        {
            $("#login_phone").parents('.form-group').addClass("has-error");
            $("#login_phone_error").html(txt_otvc.phone_missing);
            $("#login_phone_error").show();
            return false;
        }
        if (!$("#login_phone").intlTelInput("isValidNumber"))
        {
            $("#login_phone").parents('.form-group').addClass("has-error");
            $("#login_phone_error").html(txt_otvc.phone_incorrect);
            $("#login_phone_error").show();
            return false;
        }
        else
        {

            $("#m-tacphone").show();
            $("#m-verfiyphone").hide();
            $("#m-confirmphone").hide();
            $("#timer_txt").hide();
            $("#request_txt").hide();
            $("#btn_resend").hide();
            $("#keyinsms").hide();
            $("#keyinsms_already").show();
        }
    });

    //confirm code
    $(".login_confirmphonetac").bind("click", function () {

        if ($(".login_confirmphonetac").hasClass("disabled")) {
            return false;
        } else {

            var sms_code = '';
            $(".clock").each(function (index) {
                var v = $(this).val();
                v = v.trim();
                if (v!='')
                {
                    sms_code += v;
                }
            });

            $("#login_code").val(sms_code);

            var tacType = $("#tacType").val();
            var login_code = $("#login_code").val();
            $("#login_code_error").hide();
            var _this = $(this);

            //  var login_phone = $("#login_phone").val();
            var login_phone = $("#login_phone").intlTelInput("getNumber");
            if (login_code=='')
            {
                $("#login_code_error").html('Please enter sms code');
                $("#login_code_error").show();
                return false;
            }
            else
            {
                var platform_id = $("#imp_platform_id").val();
                if (typeof platform_id=='undefined' || platform_id==null || platform_id=='' || platform_id==0) platform_id = 1;

                var countryData = $("#login_phone").intlTelInput("getSelectedCountryData");
                selectedDialCode = countryData['dialCode'];

                var logintype = $("#logintype").val();

                var jsonData = {
                    type: tacType,
                    country_code: selectedDialCode,
                    recipient: login_phone,
                    code: login_code,
                    '_token': $('meta[name="csrf-token"]').attr('content'),
                };

                var request = $.ajax({
                    url: canvas_url+"api/jobseeker/verifyTac",
                    data: jsonData,
                    type: 'GET',
                    crossDomain: true,
                    dataType: 'json'
                });

                _this.button("loading");

                request.done(function (data) {

                    _this.button("reset");

                    if (data.success)
                    {

                        $.updateUserVerified();
                    }
                    else
                    {
                        disableButton('allReset');
                        $("#login_code_error").html(data.error);
                        $("#login_code_error").show();
                        $("#footer-cs").show();
                    }
                });

                request.fail(function (jqXHR, textStatus) {
                    _this.button("reset");
                    disableButton('allReset');
                    $("#login_code_error").html('Oops, something went wrong. Please try again later.');
                    $("#login_code_error").show();
                    $("#footer-cs").show();
                });
            }
        }
    });


    var is_register = false;
    $.updateUserVerified = function ()
    {
        var logintype = $("#logintype").val();

        if (logintype==='byphone')
        {
            var generateotvcid = $("#generateotvcid").val();
            var selectedDialCode = $("#m-verfiyphone .selected-dial-code").text();
            if (selectedDialCode=='')
                selectedDialCode = '60';
            else selectedDialCode = selectedDialCode.replace("+",'');

            var login_phone = $("#login_phone").intlTelInput("getNumber");
            login_phone = login_phone.replace("+",'');

            var jsonData = {
                'phone' : login_phone,
                'id' : generateotvcid,
                'country_code' : selectedDialCode,
                '_token': $('meta[name="csrf-token"]').attr('content')
            };


            var request = $.ajax({
                url: canvas_url + "api/jobseeker/phoneLogin",
                data: jsonData,
                type: 'POST',
                crossDomain: true,
                dataType: 'json'
            });

            request.done(function (data) {
                disableButton('allReset');

                if (data.success)
                {
                    ga('send', 'event', 'Login', 'phone-login','success');
                    $.notify({message: notify_msg.success.login}, {type: 'success',z_index:3000});
                    if(referrer !== '')
                    {
                        window.location = referrer;
                    }
                    else
                    {
                        window.location = canvas_url;
                    }
                }
                else {
                    ga('send', 'event', 'Login', 'phone-login','failed');
                    disableButton('allReset');
                    $("#login_code_error").html(data.status);
                    $("#login_code_error").show();
                    $("#footer-cs").show();
                }
            });

            request.fail(function (jqXHR, textStatus) {
                ga('send', 'event', 'Login', 'phone-login','failed');
                disableButton('allReset');
                $("#login_code_error").html('Oops, something went wrong. Please try again later.');
                $("#login_code_error").show();
                $("#footer-cs").show();
            });
        }
        else if(logintype==='register'){


            var phone = $("#login_phone").intlTelInput("getNumber");
            phone = phone.replace("+",'');

            var name = $("#register_name").val();
            var email = $("#register_email").val();
            var password = $("#register_password").val();

            var jsonData = {
                'name': name,
                'email': email,
                'password': password,
                'phone': phone,
                '_token': $('meta[name="csrf-token"]').attr('content'),
                '_method': "POST"
            };

            var request = $.ajax({
                url: canvas_url+"api/jobseeker/register",
                data: jsonData,
                type: 'POST',
                crossDomain: true,
                dataType: 'json'
            });

            request.done(function (data) {

                disableButton('allReset');

                if (data.success)
                {
                    ga('send', 'event', 'Login', 'normal-register','success');
                    $.notify({message: notify_msg.success.login}, {type: 'success',z_index: 3000});
                    if(referrer !== '')
                    {
                        window.location = referrer;
                    }
                    else
                    {
                        window.location = canvas_url;
                    }
                }
                else
                {
                    ga('send', 'event', 'Login', 'normal-register','failed');
                    disableButton('allReset');
                    $("#login_code_error").html('Oops, something went wrong. Please try again later.');
                    $("#login_code_error").show();
                    $("#footer-cs").show();
                }
            });

            request.fail(function (jqXHR, textStatus) {
                console.log(123);
                disableButton('allReset');
                $("#login_code_error").html('Oops, something went wrong. Please try again later.');
                $("#login_code_error").show();
                $("#footer-cs").show();
            });
        }
        else if(logintype==='googleSignup')
        {
            var generateotvcid = $("#generateotvcid").val();
            var selectedDialCode = $("#m-verfiyphone .selected-dial-code").text();
            if (selectedDialCode=='')
                selectedDialCode = '60';
            else selectedDialCode = selectedDialCode.replace("+",'');
            var fbuid         = $("#fbuid").val();
            var login_phone = $("#login_phone").intlTelInput("getNumber");
            login_phone = login_phone.replace("+",'');
            var fbaccesstoken     = $("#fbaccesstoken").val();
            var email_address     = $("#email_address").val();


            var jsonData = {
                country_code: selectedDialCode,
                phone: login_phone,
                email_address: email_address,
                password: '',
                uid: fbuid,
                access_token: fbaccesstoken,
                login_type: 'googleLogin',
                'id': 'ea78e',
                '_token': $('meta[name="csrf-token"]').attr('content'),
                '_method': "POST"
            };

            var request = $.ajax({
                url: canvas_url+"api/jobseeker/verifiedlogin",
                data: jsonData,
                type: 'POST',
                crossDomain: true,
                dataType: 'json'
            });


            request.done(function (data) {

                disableButton('allReset');

                if (data.status === 'success')
                {
                    ga('send', 'event', 'Login', 'google-signup','success');
                    $.notify({message: notify_msg.success.login}, {type: 'success',z_index: 3000});
                    if(referrer !== '')
                    {
                        window.location = referrer;
                    }
                    else
                    {
                        window.location = canvas_url;
                    }
                }
            });

            request.fail(function (jqXHR, textStatus) {
                ga('send', 'event', 'Login', 'google-signup','failed');
                disableButton('allReset');
                $("#login_code_error").html('Oops, something went wrong. Please try again later.');
                $("#login_code_error").show();
                $("#footer-cs").show();
            });

        }
        else
        {
            var selectedDialCode = $("#m-verfiyphone .selected-dial-code").text();
            if (selectedDialCode=='')
                selectedDialCode = '60';
            else selectedDialCode = selectedDialCode.replace("+",'');

            var login_phone = $("#login_phone").intlTelInput("getNumber");
            login_phone = login_phone.replace("+",'');
            var fbaccesstoken     = $("#fbaccesstoken").val();


            var jsonData = {
                countryCode: selectedDialCode,
                phoneNumber: login_phone,
                token: fbaccesstoken,
                'id': 'ea78e',
                '_token': $('meta[name="csrf-token"]').attr('content'),
                '_method': "POST"
            };

            var request = $.ajax({
                url: canvas_url+"api/jobseeker/fbsignup",
                data: jsonData,
                type: 'POST',
                crossDomain: true,
                dataType: 'json'
            });

            request.done(function (data) {

                disableButton('allReset');

                if (data.success)
                {
                    ga('send', 'event', 'Login', 'facebook-signup','success');
                    $.notify({message: notify_msg.success.login}, {type: 'success',z_index: 3000});
                    if(referrer !== '')
                    {
                        window.location = referrer;
                    }
                    else
                    {
                        window.location = canvas_url;
                    }
                }
            });

            request.fail(function (jqXHR, textStatus) {
                ga('send', 'event', 'Login', 'facebook-signup','failed');
                disableButton('allReset');
                $("#login_code_error").html('Oops, something went wrong. Please try again later.');
                $("#login_code_error").show();
                $("#footer-cs").show();
            });

        }
    }


    $(".fblogin").bind("click", function () {

        var $btn = $(this);
        $btn.button("loading");
        $("#logintype").val('fblogin');
        disableButton('fbLoginButton');
        if (typeof(FB) != 'undefined' && FB != null ) {
            FB.login(function (response) {
                if (response.status === 'connected') {
                    access_token = FB.getAuthResponse()['accessToken'];
                    FB.api('/me', function (resp) {
                        uid = response.authResponse.userID;
                        var userId = response.authResponse.userID;
                        var userName = resp.name;
                        var userEmail = resp.email;
                        $("#fbid").val(userId);
                        $("#register_name").val(userName);
                        $("#register_email").val(userEmail);

                        $("#fbuid").val(userId);
                        $("#fbaccesstoken").val(access_token);

                        var jsonData = {
                            'token': access_token,
                            '_token': $('meta[name="csrf-token"]').attr('content')
                        };


                        var request = $.ajax({
                            url: canvas_url + "api/jobseeker/fbLogin",
                            data: jsonData,
                            type: 'POST',
                            crossDomain: true,
                            dataType: 'json'
                        });

                        request.done(function (data) {
                            $btn.button('reset');
                            disableButton('allReset');

                            if (data.success)
                            {
                                ga('send', 'event', 'Login', 'facebook-login','success');
                                $.notify({message: notify_msg.success.login}, {type: 'success',z_index: 3000});
                                if(referrer !== '')
                                {
                                    window.location = referrer;
                                }
                                else
                                {
                                    window.location = canvas_url;
                                }
                            }
                            else
                            {
                                ga('send', 'event', 'Login', 'facebook-login','new user');
                                $.verifyphone('Verify phone','login_modal','fblogin');
                            }
                        });

                        request.fail(function (jqXHR, textStatus) {
                            ga('send', 'event', 'Login', 'facebook-login','failed');
                            $.verifyphone('Verify phone','login_modal','fblogin');
                            disableButton('allreset');
                            $('.fblogin').button('reset');
                            $('.googleLogin').removeAttr('disabled');
                            $('.phone-login').removeAttr('disabled');
                            $('.email-login').removeAttr('disabled');
                            $('.password-login').removeAttr('disabled');
                            $('.button-login').removeAttr('disabled');
                        });

                    });
                } else {
                    $btn.button('reset');
                    disableButton('allreset');
                    $('.fblogin').button('reset');
                    $('.googleLogin').removeAttr('disabled');
                    $('.phone-login').removeAttr('disabled');
                    $('.email-login').removeAttr('disabled');
                    $('.password-login').removeAttr('disabled');
                    $('.button-login').removeAttr('disabled');
                }
            }, {
                scope: 'email'
            });
        }
    });

    //---------- normal signup --------//
    $('#form_signup_modal').validate({
        rules :{
            register_name : {required :true},
            register_email : {required :true,email:true},
            register_password : {required:true, minlength: 8},

        },
        messages : {
            register_name : {
                required:'This field is required',
            },
            register_email : {
                required:'This field is required',
                email:'Please enter correct email address'
            },
            register_password : {
                required:'This field is required',
                minlength:'Minimum 8 charactar'
            }

        },
        submitHandler: function() {
            //using default submit function below
            return false;
        }
    });

    $("#form_signup_modal").on('submit', function(){
        var _this = $(this);
        var submitBtn = _this.find('.btn');
        _this.prev('.alert').hide()

        if ($('#form_signup_modal').valid()) {

            submitBtn.button("loading");

            //verify phone
            $.verifyphone('Verify phone','signup_modal','register');

        }
    });

    //send code
    $(".login_sendphonetac").bind("click", function () {

        if ($('#timer-111').hasClass("timerstarted")) {
            $.notify(
                {title: '', message: 'You can only send request after 1 minute.'},
                {type: "danger",z_index:3000}
            );
            return false;
        }
        var _this = $(this);
        var login_phone = $("#login_phone").intlTelInput("getNumber");
        var logintype = $("#logintype").val();
        var countryData = $("#login_phone").intlTelInput("getSelectedCountryData");
        selectedDialCode = countryData['dialCode'];

        $('.tac-input').find('input').val('');
        $("#login_phone_error").hide();
        $("#login_phone").parents('.form-group').removeClass("has-error");
        $("#login_code_error").hide();


        $("#keyinsms").show();
        $("#keyinsms_already").hide();


        var cleanLoginPhone = login_phone.replace("+",'');
        if (login_phone == '' || cleanLoginPhone == selectedDialCode)
        {
            $("#login_phone").parents('.form-group').addClass("has-error");
            $("#login_phone_error").html(txt_otvc.phone_missing);
            $("#login_phone_error").show();
            return false;
        }
        if (!$("#login_phone").intlTelInput("isValidNumber"))
        {
            $("#login_phone").parents('.form-group').addClass("has-error");
            $("#login_phone_error").html(txt_otvc.phone_incorrect);
            $("#login_phone_error").show();
            ga('send', 'event', 'Phone Validation', 'invalid phone number via TelInput',login_phone);
            return false;
        }
        else
        {

            var tacType =  $(this).data("type");

            var platform_id = $("#imp_platform_id").val();
            if (typeof platform_id=='undefined' || platform_id==null || platform_id=='' || platform_id==0) platform_id = 1;


            //confirm phone number
            var isPhoneConfirmed = $("#isPhoneConfirmed").val();
            if (isPhoneConfirmed=='no')
            {
                $('#m-verfiyphone').hide();
                $('#m-confirmphone').show();
                $('.login_confirmphone2').hide();
                $('.login_confirmphone').show();
                $("#lgconfirmphone").html(formatPhoneNumber(login_phone));

                var tacType =  $(this).data("type");
                $('#tacType').val(tacType);
                return false;
            }else{
                $('#m-verfiyphone').show();
                $('.login_confirmphone2').hide();
                $('.login_confirmphone').show();
                $('#m-confirmphone').hide()
            }

            var jsonData = {
                type: $('#tacType').val(),
                recipient: login_phone,
                country_code: selectedDialCode,
                '_token': $('meta[name="csrf-token"]').attr('content'),
            };

            var request = $.ajax({
                url: canvas_url+"api/jobseeker/generateTac",
                data: jsonData,
                type: 'GET',
                crossDomain: true,
                dataType: 'json'
            });


            _this.button("loading");
            $(".login_callphonetac").addClass('disabled');
            _this.siblings().addClass('disabled');
            $("#login_phone").attr("disabled",true);

            try {
                var tacSource = $("#tac_source").val();
            }catch (e){
                console.log(e);
            }

            request.done(function (data) {
                _this.button("reset");
                _this.siblings().removeClass('disabled');
                $(".login_callphonetac").removeClass('disabled');
                $("#login_phone").attr("disabled",true);

                if (data.success)
                {

                    $.jobunlockClick(111,60);
                    $("#generateotvcid").val(data.id);
                    $("#generateotvc").val(data.code);
                    $('#m-tacphone').show();
                    $('#m-verfiyphone').hide();
                    $('#m-confirmphone').hide();
                    $('#timer-111').show();
                    $('#request_txt').show();
                    $('#sms_text').hide();
                    $('#btn_resend').hide();


                    if(tacType == "whatsapp"){
                        $.notify({message: txt_otvc.sent_whatsapp}, {type: 'warning',z_index: 3000});
                    }else if(tacType == "sms"){
                        $.notify({message: txt_otvc.sent_sms}, {type: 'warning',z_index: 3000});
                    }
                    $(".btn-requesttacagain").show().addClass('disabled');
                }
                else
                {
                    if (data.status=='validation_error')
                    {
                        $("#login-error").html('Please enter correct phone number.');
                    }
                    else
                    {
                        $("#login-error").html(data.error);
                    }

                    $("#login-error").show();
                    _this.button("reset");
                    _this.siblings().removeClass('disabled');
                    $("#login_phone").attr("disabled",false);

                }
            });

            request.fail(function (jqXHR, textStatus) {
                _this.button("reset");
                _this.siblings().removeClass('disabled');
                $("#login_phone").attr("disabled",false);

                $("#login-error").html('Invalid Phone Number. Please enter correct phone number.');
                $("#login-error").show();
                $("#login-footer").show();

            });
        }
    });
});

$.showRegisterModal = function (){
    disableButton('emailLoginReset');
    $('#signup_modal_jobseeker_login').modal('show');
}

var googleUser = {};
var google_client_id = googleClientId;
var startApp = function() {
    gapi.load('auth2', function(){
        auth2 = gapi.auth2.init({
            client_id: google_client_id,
            cookiepolicy: 'single_host_origin',
        });
        attachSignin(document.getElementById('loginGoogleBtn'));
        attachSignin(document.getElementById('signupGoogleBtn'));
    });
};

function attachSignin(element) {

    auth2.attachClickHandler(element, {},
        function(googleUser) {
            var _this = $(this);
            var submitBtn = _this.find('.btn');
            _this.prev('.alert').hide()
            var profile = googleUser.getBasicProfile();
            var email = profile.getEmail();
            var userId = profile.getId();
            var name = profile.getName();
            var profileImage = profile.getImageUrl();
            var token = {};
            token['Paa'] = profileImage;
            token['ig'] = name;
            token['Eaa'] = userId;

            $("#logintype").val('googlelogin');

            $("#email_address").val(email);
            $("#fbaccesstoken").val(JSON.stringify(token));


            var jsonData = {
                'access_token': JSON.stringify(token),
                'uid': userId,
                'name' : name,
                'email' : email,
                'user_type': 'jobseeker',
                'profileImage' : profileImage,
                'id': 'ea78e',
                'login_type':'google',
                '_token': $('meta[name="csrf-token"]').attr('content'),
                '_method': "POST"
            };


            var request = $.ajax({
                url: canvas_url + "api/jobseeker/logincheck",
                data: jsonData,
                type: 'POST',
                crossDomain: true,
                dataType: 'json'
            });

            disableButton('allReset');
            request.done(function (data) {
                submitBtn.button("reset");
                disableButton('allReset');

                if (data.status ==='success')
                {
                    ga('send', 'event', 'Login', 'google-login','success');
                    $.notify({message: notify_msg.success.login}, {type: 'success',z_index: 3000});
                    if(referrer !== '')
                    {
                        window.location = referrer;
                    }
                    else
                    {
                        window.location = canvas_url;
                    }
                }
                else
                {
                    ga('send', 'event', 'Login', 'google-login','new user');
                    $.verifyphone('Verify phone','login_modal','googleSignup');
                }
            });

            request.fail(function (jqXHR, textStatus) {
                ga('send', 'event', 'Login', 'google-login','failed');
                $.verifyphone('Verify phone','login_modal','googleSignup');
            });
        },
        function(error) {
            disableButton('googleLoginReset');
            console.log(JSON.stringify(error, undefined, 2));
        });

}


$(".toggle-password").click(function() {

    $(this).toggleClass("fa-eye fa-eye-slash");
    var input = $($(this).attr("toggle"));
    if (input.attr("type") == "password") {
        input.attr("type", "text");
    } else {
        input.attr("type", "password");
    }
});

$('#resend-toggle').on('click', function () {
    $(this).hide();
    $('#resend-section').show();
});

function formatPhoneNumber(phoneNumberString) {
    var cleaned = phoneNumberString.replace(/[^\d]/g, "");
    var len = cleaned.length;
    var match = cleaned.match(/(\d{2})(\d{3})(\d{4})(\d{4})/);
    if(len == 12)
    {
        var match = cleaned.match(/(\d{2})(\d{3})(\d{3})(\d{4})/);
    }
    if (match) {
        return '+' + match[1] + ' ' + match[2] + ' ' + match[3]+ ' ' + match[4];
    }
    return cleaned;
}













